// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Container, Title } from './styles';

// defs
export interface ProductTagsConfig {
  bgColor?: string;
  titleColor?: string;
  borderColor?: string;
  transparency_web?: number;
}

interface TagProps {
  item: Listing.IProductTag;
  className: string;
  saleExp?: boolean;
  productTagsConfig?: ProductTagsConfig;
}

function Tag({ item, className, saleExp, productTagsConfig = {} }: TagProps) {
  if (isEmpty(item)) return null;
  const { title, titleColor, bgColor, borderColor, transparency_web } = item;

  const tagConfig = {
    bgColor: productTagsConfig.bgColor || bgColor,
    titleColor: productTagsConfig.titleColor || titleColor,
    borderColor: productTagsConfig.borderColor || borderColor,
    transparency_web: productTagsConfig.transparency_web || transparency_web,
  };

  return (
    <Container
      bgColor={tagConfig.bgColor}
      borderColor={tagConfig.borderColor}
      transparency_web={tagConfig.transparency_web}
      className={className}
      saleExp={saleExp}
    >
      <Title aria-label={title} titleColor={tagConfig.titleColor}>{title}</Title>
    </Container>
  );
}

export default memo(Tag);
